import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Badge, BadgeType } from "src/components";

export type SubscribersCounterProps = {
    count: number | undefined;
};

export const SubscribersCounter: FC<SubscribersCounterProps> = ({ count }) => {
    const { t } = useTranslation();

    return <Badge text={t("userManagement.subscribersCount", { count: count ?? 0 })} type={BadgeType.neutral} />;
};
